import React from 'react';
import styled from 'styled-components';

interface IRightQuote extends React.HTMLAttributes<HTMLDivElement> {
  color?: any;
}

export const RightQuote: React.FC<IRightQuote> = ({ style, className }) => {
  return (
    <RightQuoteStyle style={style} className={className}>
      <svg
        width="27"
        height="19"
        viewBox="0 0 27 19"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.3252 18.8158C21.62 16.1684 26.2316 10.3612 26.2316 4.981C26.2316 1.6504 24.182 0.0277995 21.7054 0.0277993C19.058 0.027799 16.5814 2.2482 16.5814 5.0664C16.5814 7.3722 18.2894 8.9094 20.2536 8.9094C20.4244 8.9094 20.8514 8.9094 20.9368 8.824C19.9974 11.6422 16.8376 14.4604 13.7632 15.9976L16.3252 18.8158ZM2.74659 18.8158C8.04139 16.1684 12.653 10.3612 12.653 4.981C12.653 1.6504 10.6034 0.0277983 8.12679 0.0277981C5.47939 0.0277978 3.00279 2.2482 3.00279 5.0664C3.00279 7.3722 4.71079 8.9094 6.58959 8.9094C6.84579 8.9094 7.18739 8.9094 7.35819 8.824C6.33339 11.6422 3.25899 14.4604 0.184586 15.9976L2.74659 18.8158Z"
          fill="#e8c893"
        />
      </svg>
    </RightQuoteStyle>
  );
};

const RightQuoteStyle = styled.div`
  position: relative;
  display: inline-flex;
  align-items: flex-end;
  right: 0;
  color: ${({ theme }) => theme.colors.primary};
`;

export default RightQuote;
